import { render, staticRenderFns } from "./tab5.vue?vue&type=template&id=01beb833&"
import script from "./tab5.vue?vue&type=script&lang=js&"
export * from "./tab5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports